import { Fragment, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { useTranslation } from "react-i18next";
// import Loader from "./../../component/Loader";
// import {
//   getContactInfo,
//   formContact,
//   getSocialMedia,
// } from "../../store/contact/contactAction";
// import { sucess, failed } from "../../component/toast/Toast";
// import { useFormik } from "formik";
// import { Link } from "react-router-dom";
import bgConatct from "../../assets/image/01.jpg";
import img from "../../assets/images/resources/achieved_1-img-2.jpg";
import BreadBanner from "../../component/BreadBanner";

const Contact = () => {
  // const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);

  // const formik = useFormik({
  //   initialValues: {
  //     name: "",
  //     email: "",
  //     phone: "",
  //     message: "",
  //   },
  //   validateOnChange: true,
  //   onSubmit: (values) => {
  //     dispatch(formContact(values)).then((result) => {
  //       if (!result.error) {
  //         sucess(t("Congrats ... we will contact you soon"));
  //       } else {
  //         failed(t("please try again later ... "));
  //       }
  //     });
  //   },
  // });

  // const { info, SocialMedia, loading } = useSelector(
  //   (state) => state.contactSlice
  // );

  // const stripHtmlTags = (html) => {
  //   const doc = new DOMParser().parseFromString(html, "text/html");
  //   return doc.body.textContent || "";
  // };
  // const mapinfo = stripHtmlTags(
  //   info
  //     ?.map((item) => {
  //       if (item?.name === "الخريطة") {
  //         return item?.value;
  //       }
  //       return null;
  //     })
  //     .join("")
  // );

  // useEffect(() => {
  //   dispatch(getContactInfo(lan));
  //   dispatch(getSocialMedia(lan));
  // }, [lan, dispatch]);

  return (
    <Fragment>
      <BreadBanner bg={bgConatct} title={"Contact"} span={"Contact us"} />
      <div className="contact">
        <div className="contact_map">
          <div className="container-fluid">
            <div id="google_map" className="row">
              <div className="col-12">
                <iframe
                  width="100%"
                  height="500px"
                  title="pioneers-solutions"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54972.121618771765!2d31.000865497231835!3d30.55615189406014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f7d7d37840ebe7%3A0x96dfef0923e623e9!2zUGlvbmVlcnMgU29sdXRpb25z4oCP4oCP!5e0!3m2!1sen!2seg!4v1722250839813!5m2!1sen!2seg"
                  classNameName="google-map__contact1"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        <div className="contact_info_container">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="contact_form">
                  <div className="contact_info_title">Contact Form</div>
                  <form action="#" className="comment_form">
                    <div>
                      <div className="form_title">Name</div>
                      <input
                        type="text"
                        className="comment_input"
                        required="required"
                      />
                    </div>
                    <div>
                      <div className="form_title">Email</div>
                      <input
                        type="text"
                        className="comment_input"
                        required="required"
                      />
                    </div>
                    <div>
                      <div className="form_title">Message</div>
                      <textarea
                        className="comment_input comment_textarea"
                        required="required"
                      ></textarea>
                    </div>
                    <div>
                      <button type="submit" className="comment_button trans_200">
                        submit now
                      </button>
                    </div>
                  </form>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="contact_info">
                  <div className="contact_info_title">Contact Info</div>
                  <div className="contact_info_text">
                    <p>
                      It is a long established fact that a reader will be
                      distracted by the readable content of a page when looking
                      at its layout. The point of using Lorem Ipsum is that it
                      has a distribution of letters.
                    </p>
                  </div>
                  <div className="contact_info_location">
                    <div className="contact_info_location_title">
                      New York Office
                    </div>
                    <ul className="location_list">
                      <li>T8/480 Collins St, Melbourne VIC 3000, New York</li>
                      <li>1-234-567-89011</li>
                      <li>info.deercreative@gmail.com</li>
                    </ul>
                  </div>
                  <div className="contact_info_location">
                    <div className="contact_info_location_title">
                      Australia Office
                    </div>
                    <ul className="location_list">
                      <li>Forrest Ray, 191-103 Integer Rd, Corona Australia</li>
                      <li>1-234-567-89011</li>
                      <li>info.deercreative@gmail.com</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Contact;
